"use client";
import { RegionSelect } from "#/components/selectors/region-select";
import { useCurrentRegion } from "#/hooks/use-current-region";
import { ThemeContext } from "#/providers/theme-provider";
import { useContext, useMemo } from "react";

export const SwitchRegionSelect = () => {
  const theme = useContext(ThemeContext);
  const region = useCurrentRegion();

  const getDomainForRegion = (selectedRegion: string) => {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port;

    const isProduction =
      hostname.includes("streamorders.com") ||
      hostname.includes("streamyourpos.com");
    let targetDomain: string;

    if (isProduction) {
      if (selectedRegion === "eu") {
        targetDomain = "eu.streamorders.com";
      } else if (selectedRegion === "au") {
        targetDomain = "au.streamorders.com";
      } else {
        targetDomain = "streamyourpos.com";
      }
    } else {
      const baseDomain = hostname.replace(/^(eu\.|au\.)/, "");

      if (selectedRegion === "eu") {
        targetDomain = `eu.${baseDomain}`;
      } else if (selectedRegion === "au") {
        targetDomain = `au.${baseDomain}`;
      } else {
        targetDomain = baseDomain;
      }
    }

    return `${protocol}//${targetDomain}${port ? `:${port}` : ""}`;
  };

  const partnerWithEU = useMemo(
    () => theme.name?.toLowerCase().includes("stream"),
    [theme.name],
  );

  if (!partnerWithEU) return <></>;

  return (
    <RegionSelect
      value={region}
      onChange={(value) => {
        const targetUrl = getDomainForRegion(value);
        window.location.href = targetUrl;
      }}
    />
  );
};
